// Components
import { Textarea } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function Memo(): JSX.Element {
  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="memo"
      control={control}
      render={({ field, fieldState }) => (
        <Textarea
          {...field}
          label="MEMO"
          error={fieldState.error?.message}
        />
      )}
    />
  )
}